import React, { useEffect, useRef, useState } from 'react';
import jianf from 'images/industry-jiankang-jianf.png';
import caseJianf from 'images/case-jianf-img.jpg';

const caseList = [
  {
    img: caseJianf,
    icon: jianf,
    name: '尘锋SCRM',
    title: '企微SCRM助力商家私域能力再进阶',
    desc: '某品械赛道商家通过尘锋SCRM工具，线上化运营sop，优化管理界面，提升管理效率；标签化客户分层，以千人千面的营销玩法提高内容服务与潜客的匹配效率，降低客资转化成本；将开口，下定和下单等行为数据上报，深度辅助优化广告模型，提升开口率和下单率等，实现营销全链路效果提升。',
    effectList: [
      { label: '开口率提升', value: 200, unit: '%+' },
      { label: '辅助下单率提升', value: 15, unit: '%' },
    ],
  },
  {
    img: 'https://union.gdtimg.com/webstore/case-yun-que.jpg',
    icon: 'https://union.gdtimg.com/webstore/fb14a18a-440b-439f-82ae-91e673676743.png',
    name: '云雀客服',
    title: '覆盖推广/销售等多环节的公众号智能客服',
    desc: '为解决某婚摄客户客服团队需要通过公众号服务日渐增长的海量客户的问题，云雀客服为其提供了“自动追粉”（48小时追粉）功能，将接待新粉丝的工作自动化、长期化，线上客服团队因此从8人减少至2人，节省了大量人力，同时大幅提升了推广效果。',
    effectList: [
      { label: '开口率提升', value: 100, unit: '%' },
      { label: '人效提升', value: 300, unit: '%' },
    ],
  },
  {
    img: 'https://union.gdtimg.com/webstore/case-wei-sheng.jpg',
    icon: 'https://union.gdtimg.com/webstore/icon-wei-sheng.png',
    name: '微盛企微管家',
    title: '企业微信平台客户关系综合管理工具',
    desc: '某零售品牌面临客户分散，客户管理成本高的问题，企微管家利用渠道活码将各平台分散客户汇聚企业微信，统一管理，精细运营，线上客户服务、社群运营，线上线下相互引流，协同并进。',
    effectList: [{ label: '新增企微好友', value: 360, unit: 'W', plus: true }],
  },
  {
    img: 'https://union.gdtimg.com/webstore/case-xian-shi.jpg',
    icon: 'https://union.gdtimg.com/webstore/icon-xian-shi.png',
    name: '弦石购百通',
    title: '基于购物百货真实交易数据打开线下营销新玩法',
    desc: '某品牌明星产品苦于利用常规媒体招募新客效率不高 ，弦石购场百货通帮助品牌发掘线下新场域，以商场真实交易数据为基础，结合商场本地影响力，叠加人货匹配和精细化的活动规划，精准匹配顾客，显著提升品牌获客效果。',
    effectList: [
      { label: '获客成本降低', value: 30, unit: '%' },
      { label: '30天CPS 提升', value: 126, unit: '%' },
    ],
  },
  {
    img: 'https://union.gdtimg.com/webstore/case-lan-kuang.jpg',
    icon: 'https://union.gdtimg.com/webstore/bd6bba6b-60ef-4339-8c36-81f55fb592bd.png',
    name: '蓝旷私域运营',
    title: '数据化、规模化、智能化私域运营平台',
    desc: '某投顾企业为提升企业运营效率和满足市场数据化需要，使用蓝旷私域工具通过构建以会话数据为核心的私域运营数据体系，做到客户自动画像，客户意图识别，并以此为基础实现个性化运营和智能合规，规避企业管理风险，提升企业服务满意度。',
    effectList: [
      { label: '成单转化率提升', value: 15, unit: '%' },
      { label: '人效提升', value: 300, unit: '%' },
    ],
  },
  {
    img: 'https://union.gdtimg.com/webstore/case-che-xun-da.jpg',
    icon: 'https://union.gdtimg.com/webstore/case-icon-che-xun-da.png',
    name: '腾讯车讯达',
    title: '汽车行业全景智联社交集客平台',
    desc: '某车企客户以小程序为载体，通过一键授权，开启留资与获客。LBS智能分配附近门店，一键呼起门店销售代表，即时沟通加速转化。服务通知、短信等反向唤醒，多维打通线索流转，助力线索触达门店时效性的提升。',
    effectList: [{ label: '线索触达门店时效性提升', value: 100, unit: '%' }],
  },
  // {
  //   img: 'https://union.gdtimg.com/webstore/case-ri-bao.jpg',
  //   icon: 'https://union.gdtimg.com/webstore/case-icon-ri-bao.png',
  //   name: '日报生成器',
  //   title: '自动生成每日分析报表，分维度洞察广告投放，指引广告效果优化',
  //   desc: '数据统计时间从120分钟缩减到1分钟，某游戏客户团队使用Marketin自动日报工具，节省99%工作时间。使用工具前，2名优化师每天各花费1小时人工数据拼表；使用工具后，可一目了然多账户核心数据以及多维度细化分析结果。',
  //   effectList: [
  //     { label: '人效提升', value: 100, unit: '%' },
  //     { label: '时间节省', value: 99, unit: '%' },
  //   ],
  // },
  {
    img: 'https://union.gdtimg.com/webstore/case-su-cai.jpg',
    icon: 'https://union.gdtimg.com/webstore/case-icon-su-cai.png',
    name: '素材汇总助手',
    title: '支持跨账户的素材统计及邮件订阅',
    desc: '某游戏客户团队在使用素材助手前采用人工拼表进行素材统计，每周一次素材复盘会议。使用后团队每天都会进行素材复盘，实时跟踪素材效果，及时淘汰了效果较差的素材，快速衍生优质素材，素材ROI提升了10%。',
    effectList: [
      { label: '效率提升', value: 300, unit: '%' },
      { label: 'ROI提升', value: 10, unit: '%' },
    ],
  },
  {
    img: 'https://union.gdtimg.com/webstore/case-tou-fang.jpg',
    icon: 'https://union.gdtimg.com/webstore/case-icon-tou-fang.png',
    name: '批量新建投放',
    title: '跨账户批量修改各种投放设置',
    desc: '某电商客户，双11大促期间使用九枝兰批量工具投放后，在团队规模不变的情况下，助力广告主日均投放量从50万增长到200万，单日投放量超1000万。显著提升了人员投放效率。',
    effectList: [
      { label: '人效提升', value: '3-5', unit: '倍' },
      { label: '资金周转率提升', value: 120, unit: '%' },
    ],
  },
];

const CaseInfo: React.FC<typeof caseList[number]> = ({ icon, name, title, desc, effectList }) => {
  return (
    <div className="case-info">
      <div className="text-bold name">
        <img src={icon} alt="" />
        {name}
      </div>
      <div className="text-bold title">{title}</div>
      <div className="text-desc desc">{desc}</div>
      <div className="detail">
        {(effectList as (Record<'label' | 'value' | 'unit', string> & { plus?: boolean })[]).map((effect) => (
          <div key={effect.label} className="detail-item">
            <div className="value">
              <strong>{effect.value}</strong>
              {effect.unit}
              {effect.plus && <sup>+</sup>}
            </div>
            <div className="text-desc">{effect.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

const Cases: React.FC = () => {
  const [index, setIndex] = useState<number>(0);
  const [current, setCurrent] = useState<number>(0);
  const [className, setClassName] = useState<string>();

  const interval = useRef<ReturnType<typeof setInterval>>();

  useEffect(() => {
    if (interval.current) {
      clearInterval(interval.current);
    }

    setClassName('slide-out');
    const timeout = setTimeout(() => {
      setCurrent(index);
      setClassName('');

      interval.current = setInterval(() => {
        setIndex((val) => (val + 1) % caseList.length);
      }, 10000);
    }, 500);

    return () => {
      clearInterval(interval.current);
      clearTimeout(timeout);
    };
  }, [index]);

  return (
    <section className="cases">
      <div className="fade text-bold header">经典成功案例</div>
      <div className="fade text-bold sub-header">SUCCESSFUL CASES</div>

      <div className="fade slides">
        <div className={`case-item ${className ?? ''}`}>
          <div className="img-wrapper">
            <img src={caseList[index].img} alt="" />
            {current !== index && <img src={caseList[current].img} alt="" />}
          </div>
          <CaseInfo {...caseList[current]} />
          {caseList?.map((item) => (
            <CaseInfo key={item.title} {...item} />
          ))}
        </div>
        <div className="dots">
          {caseList?.map((_, idx) => (
            <span
              key={idx}
              className={`dot ${idx === index ? 'active' : ''}`}
              role="button"
              onClick={() => setIndex(idx)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Cases;
